import apolloClient from '../apolloClient';
import { TRACK_LOGIN_EVENT } from './mutations/loginTracking';

/**
 * Track login event (success or failure)
 * @param {Object} loginData - Login tracking data
 * @param {boolean} loginData.success - Whether login succeeded
 * @param {string} loginData.email - Email used for the attempt (always required)
 * @param {string} [loginData.userId] - Customer user ID (Cognito sub) - for success
 */
export const trackLoginEventGraphQL = async (loginData) => {
  try {
    const input = {
      success: loginData.success,
      email: loginData.email,
      timestamp: new Date().toISOString()
    };

    if (loginData.success && loginData.userId) {
      input.userId = loginData.userId;
    }

    const { data } = await apolloClient.mutate({
      mutation: TRACK_LOGIN_EVENT,
      variables: {
        input
      },
      // Don't fail the login if tracking fails
      errorPolicy: 'ignore'
    });

    return data?.trackLoginEvent;
  } catch (error) {
    // Silently fail - don't let tracking errors break the login flow
    console.warn('Failed to track login event:', error);
    return null;
  }
};
